import { render, staticRenderFns } from "./red-whatsapp.vue?vue&type=template&id=abbbcebc&scoped=true"
import script from "./red-whatsapp.vue?vue&type=script&lang=js"
export * from "./red-whatsapp.vue?vue&type=script&lang=js"
import style0 from "./red-whatsapp.vue?vue&type=style&index=0&id=abbbcebc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbbcebc",
  null
  
)

export default component.exports